import { EtaType, EtaContent } from '@/types';

export const etaContent: EtaContent[] = [
  {
    type: EtaType.donorOR,
    label: 'Donor OR',
  },
  {
    type: EtaType.txCenterSta,
    label: 'TX Center STA',
  },
  {
    type: EtaType.txCenterEta,
    label: 'TX Center ETA',
  },
  {
    type: EtaType.txCenterOr,
    label: 'TX Center OR',
  },
  {
    type: EtaType.delay,
    label: 'Delay',
  },
];
